import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlipHorizontal = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 20L10.2 19.9551L10.2 4L3 20ZM4.16827 19.1927L9.48 19.1596L9.48 7.38886L4.16827 19.1927Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11.64 4V5.68889L12.36 5.68889V4H11.64ZM12.36 7.64445L11.64 7.64444V11.0222L12.36 11.0222V7.64445ZM12.36 12.9778L11.64 12.9778V16.3556L12.36 16.3556V12.9778ZM12.36 18.3111H11.64V20H12.36V18.3111Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 20L13.8 19.9551L13.8 4L21 20Z",
			fill: "currentColor"
		})
	]
});
export default SvgFlipHorizontal;
